import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { vega, vegalite, vegaliteApi } from "./dependencies.js";
export default function vl(_x) {
  return _vl.apply(this, arguments);
}

function _vl() {
  _vl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(require) {
    var _yield$Promise$all, _yield$Promise$all2, v, vl, api;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([vega, vegalite, vegaliteApi].map(function (d) {
              return require(d.resolve());
            }));

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            v = _yield$Promise$all2[0];
            vl = _yield$Promise$all2[1];
            api = _yield$Promise$all2[2];
            return _context.abrupt("return", api.register(v, vl));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _vl.apply(this, arguments);
}